import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Router from "..";

export const useBrandPaymentHistory = ({
  campaignId = null,
  status = null,
  page = 1,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["brandPaymentHistory", campaignId, status, page],
    queryFn: () => Router.Api.getBrandPaymentHistory(campaignId, status, page),
    enabled,
  });
};

export const useBrandPaymentHistoryDetail = ({
  payReportId,
  status = null,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["brandPaymentHistoryDetail", payReportId, status],
    queryFn: () => Router.Api.getBrandPaymentHistoryDetail(payReportId, status),
    enabled,
  });
};

export const useBrandPaymentRefund = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ payReportId, refundReason }) =>
      Router.Api.refundBrandPayment(payReportId, refundReason),
    onSuccess: (ok, variables) => {
      if (!ok) return;
      queryClient.invalidateQueries({ queryKey: ["brandPaymentHistory"] });
      queryClient.invalidateQueries({
        queryKey: ["brandPaymentHistoryDetail", variables.payReportId],
      });
    },
  });
};

export const useInfluencerPaymentHistory = ({
  campaignId = null,
  status = null,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["influencerPaymentHistory", campaignId, status],
    queryFn: () => Router.Api.getInfluencerPaymentHistory(campaignId, status),
    enabled,
  });
};

export const useAgencyPaymentHistory = ({
  campaignId = null,
  status = null,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["agencyPaymentHistory", campaignId, status],
    queryFn: () => Router.Api.getAgencyPaymentHistory(campaignId, status),
    enabled,
  });
};

export const useConfirmPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => Router.Api.confirmPayment(payload),
    onSuccess: (ok, variables) => {
      if (!ok) return;
      queryClient.invalidateQueries({ queryKey: ["brandPaymentHistory"] });
    },
  });
};

export const useBankTransferPaymentRefund = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ payReportId, refundReason }) =>
      Router.Api.refundBankTransferPayment(payReportId, refundReason),
    onSuccess: (ok, variables) => {
      if (!ok) return;
      queryClient.invalidateQueries({ queryKey: ["brandPaymentHistory"] });
      queryClient.invalidateQueries({
        queryKey: ["brandPaymentHistoryDetail", variables.payReportId],
      });
    },
  });
};

export const useBrandRejectedRefund = (pay_report_id, enabled = true) => {
  return useQuery({
    queryKey: ["brandRejectedRefund", pay_report_id],
    queryFn: () => Router.Api.getRejectedRefund(pay_report_id),
    enabled: enabled && Boolean(pay_report_id),
  });
};
